export default {
  init() {
    jQuery('.wpcf7-custom-submit').on('click', function () {
      jQuery(this).closest('form').submit();
    });

    jQuery('#menu_toggle').on('click', () => {
      jQuery('nav.nav-primary').fadeToggle(200);
    });

    jQuery('.main-carousel').flickity({
      groupCells: true,
      imagesLoaded: true,
      contain: true,
      initialIndex: '.is-initial-select',
      cellAlign: 'center',
      pageDots: false,
    });

    jQuery('.autoplay').flickity({
      groupCells: true,
      contain: true,
      cellAlign: 'center',
      pageDots: false,
      prevNextButtons: false,
      autoPlay: 3500,
    });

    jQuery('.logo-carousel').flickity({
      groupCells: true,
      imagesLoaded: true,
      contain: true,
      initialIndex: '.is-initial-select',
      cellAlign: 'center',
      pageDots: false,
      autoPlay: 3500,
    });

    jQuery(window).resize(this.resizeMenu);
    jQuery(document).ready(this.resizeMenu);

    // Add 'scrolled' class to the banner when page is scrolled
    jQuery(window).on('scroll', function () {
      if (jQuery(window).scrollTop() > 0) {
          jQuery('.banner').addClass('scrolled');
      } else {
          jQuery('.banner').removeClass('scrolled');
      }
  });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
  resizeMenu() {
    if (jQuery(window).width() < 992) {
      jQuery('.nav-primary').removeAttr('style');
      jQuery('.content-secondary-navigation').css(
        'padding-top',
        jQuery('.banner__container').outerHeight() + 15
      );
    } else {
      jQuery('.content-secondary-navigation').removeAttr('style');
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js